import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import * as constants from './constants';
import { StoreState, CourseStatsAction } from './typings';

const initialState: StoreState = {
    coursesStats: {},
};

const courseStatReducer = (state: StoreState = initialState, action: CourseStatsAction) => {
    return produce(state, (draft) => {
        // eslint-disable-line complexity
        const courseId: number = action.courseId;

        if (!courseId) {
            return;
        }

        if (!state.coursesStats[courseId]) {
            draft.coursesStats[courseId] = {
                loadingStatus: LOADING_STATUSES.UNSENT,
                stats: null,
            };
        }

        switch (action.type) {
            case constants.GET_COURSE_STATS_REQUEST:
                draft.coursesStats[courseId].loadingStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.GET_COURSE_STATS_SUCCESS: {
                draft.coursesStats[courseId].loadingStatus = LOADING_STATUSES.SUCCESS;
                draft.coursesStats[courseId].stats = action.stats;
                break;
            }

            case constants.GET_COURSE_STATS_ERROR:
                draft.coursesStats[courseId].loadingStatus = LOADING_STATUSES.ERROR;
                break;

            case constants.CLEAR_COURSE_STATS: {
                draft.coursesStats[courseId].loadingStatus = LOADING_STATUSES.UNSENT;
                draft.coursesStats[courseId].stats = null;
                break;
            }

            default:
                break;
        }
    });
};

export default courseStatReducer;
